// src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // true au départ

  // 🔁 Charger la session depuis localStorage
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (e) {
        console.error('Token invalide', e);
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, []);


  // Connexion : on stocke le token + payload
  const login = (token) => {
    sessionStorage.setItem("token", token);
    const decoded = jwtDecode(token);
    setUser(decoded);

    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user", JSON.stringify(decoded));
  };
    // Restaurer la session à chaque rechargement
    
    useEffect(() => {
        const savedUser = sessionStorage.getItem("user");
        if (savedUser) {
        setUser(JSON.parse(savedUser));
        }
    }, []);
    

  // Déconnexion
  const logout = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("token");
    sessionStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personnalisé pour l'utiliser facilement
export const useAuth = () => useContext(AuthContext);
